export const getBoundsFromLatLngLocations = <L extends google.maps.LatLngLiteral>(
  locations: L[]
): google.maps.LatLngBounds => {
  const bounds = new google.maps.LatLngBounds();

  locations.forEach(location => {
    bounds.extend(location);
  });

  return bounds;
};

export const extendSingleLatLngBounds = (
  bounds: google.maps.LatLngBounds,
  extendAmount: number
): google.maps.LatLngBounds => {
  const latPerMeter = 0.00000899322;
  const lngPerMeter = 0.00000899828;
  const latDiff = extendAmount * latPerMeter;
  const lngDiff = (extendAmount * lngPerMeter) / Math.cos((bounds.getCenter().lat() * Math.PI) / 180);
  const neExtender = new google.maps.LatLng(
    bounds.getNorthEast().lat() + latDiff,
    bounds.getNorthEast().lng() + lngDiff
  );
  const swExtender = new google.maps.LatLng(
    bounds.getSouthWest().lat() - latDiff,
    bounds.getSouthWest().lng() - lngDiff
  );
  bounds.extend(neExtender);
  bounds.extend(swExtender);
  return bounds;
};
